// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import YahooFilledSvg from "@fishx/icons-svg/es/asn/YahooFilled";
import FishxIcon from '../components/FishxIcon';

var YahooFilled = function YahooFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: YahooFilledSvg
  }));
};

YahooFilled.displayName = 'YahooFilled';
export default React.forwardRef(YahooFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/YahooFilled.js
// module id = 4411
// module chunks = 0